// ====== DISCUSSION TAB FEATURE START ======
export async function uploadDiscussionAttachment(file) {
    if (!file) return null;
    const formdata = new FormData();
    formdata.append("file", file, file.name);
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: token,
      },
      body: formdata,
      redirect: "follow",
    };
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}v1/file-upload/upload`, requestOptions);
      const result = await response.json();
      // Expect result to have at least { url, ... }
      return result;
    } catch (error) {
      return null;
    }
  }
  // ====== DISCUSSION TAB FEATURE END ====== 